export const SCRIPT_ID = 'TrellisLinkSpeculationRules';

export const prerenderSelectors = {
  conservative: 'prerender-c',
  eager: 'prerender-e',
  moderate: 'prerender-m',
};

export type SpeculationAlgorithm = 'conservative' | 'eager' | 'moderate';

type SpeculationRules = {
  prerender: Array<{
    eagerness: SpeculationAlgorithm;
    source: 'document';
    where: {
      and: {
        selector_matches: string;
      }[];
    };
  }>;
};

function createSpeculationRules(): SpeculationRules {
  return {
    prerender: [
      {
        source: 'document',
        where: {
          and: [{ selector_matches: '[data-prerender=prerender-c]' }],
        },
        eagerness: 'conservative',
      },
      {
        source: 'document',
        where: {
          and: [{ selector_matches: '[data-prerender=prerender-e]' }],
        },
        eagerness: 'eager',
      },
      {
        source: 'document',
        where: {
          and: [{ selector_matches: '[data-prerender=prerender-m]' }],
        },
        eagerness: 'moderate',
      },
    ],
  };
}

function isSpeculationSupported(): boolean {
  return !!(
    HTMLScriptElement.supports && HTMLScriptElement.supports('speculationrules')
  );
}

function isScriptSet(): boolean {
  return !!document.getElementById(SCRIPT_ID);
}

export default function setSpeculationRules(): void {
  if (!isSpeculationSupported() || isScriptSet()) {
    return;
  }

  const newScript = document.createElement('script');
  newScript.id = SCRIPT_ID;
  newScript.type = 'speculationrules';
  newScript.textContent = JSON.stringify(createSpeculationRules());

  document.body.append(newScript);
}
